import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PhoneNumberFormatService {
  formatForInput(rawValue: string): string {
    const trimmedValue = (rawValue || '').trim();

    if (!trimmedValue) {
      return '';
    }

    if (this.isInternationalValue(trimmedValue)) {
      return this.normalizeInternational(trimmedValue);
    }

    return this.formatUsPhone(trimmedValue);
  }

  private formatUsPhone(rawValue: string): string {
    const digits = rawValue.replace(/\D/g, '').slice(0, 10);

    if (digits.length <= 3) {
      return digits ? `(${digits}` : '';
    }

    if (digits.length <= 6) {
      return `(${digits.slice(0, 3)})${digits.slice(3)}`;
    }

    return `(${digits.slice(0, 3)})${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  }

  private normalizeInternational(rawValue: string): string {
    const hasLeadingPlus = rawValue.trim().startsWith('+');
    const digits = rawValue.replace(/\D/g, '');

    if (!digits) {
      return hasLeadingPlus ? '+' : '';
    }

    const groupedDigits = digits.match(/.{1,4}/g)?.join(' ') || digits;
    return hasLeadingPlus ? `+${groupedDigits}` : groupedDigits;
  }

  private isInternationalValue(rawValue: string): boolean {
    if (rawValue.trim().startsWith('+')) {
      return true;
    }

    const digits = rawValue.replace(/\D/g, '');
    return digits.length > 10;
  }
}
